<template>
  <div id="app" style="overflow-x: hidden;" :class='onlinestate=="pc"?"":"look_id"'>
    <div :class='islang=="eng"&&onlinestate !=="pc"?"look_en":""'>
    <router-view/>
    <div style="width: 100vw;height: 100vh;background-color: #fff;z-index: 2000;" v-if='$store.state.island'></div>
    </div>
  </div>
</template>

<script>
  document.onkeydown = () => {
    //禁用F12
    if (window.event && window.event.keyCode == 123) {
      return false;
    //禁用ctrl+ c,
    } else if (window.event.ctrlKey  && window.event.keyCode == 67) {
      return false;
    } else if(window.event.keyCode == 67 && window.event.metaKey){
      return false;
    }else if (window.event.ctrlKey && window.event.shiftKey && window.event.keyCode == 73) {
      return false;
    }else if (window.event.metaKey && window.event.shiftKey && window.event.keyCode == 73) {
      return false;
    }else if (window.event.shiftKey && window.event.keyCode == 121) {
      return false;
    }
  };
export default {
  name: 'App',
  data(){
    return{
      onlinestate:sessionStorage['onlinestate'],
      islang: window.localStorage.guanwanglang,
    }
  },
  mounted() {
    document.oncontextmenu = new Function("event.returnValue=false");
    if (!window.localStorage.guanwanglang) {
      window.localStorage.guanwanglang = "eng"
    }
    if(location.href.split('?lang=')[1]){
      let strlang = location.href.split('?lang=')[1];
      console.log(strlang , '---------------+++')
      if(window.localStorage.guanwanglang !== strlang){
        window.localStorage.guanwanglang = strlang
        setTimeout(()=>{
          location.reload();
        },200)
      }
    }

  }
}
</script>

<style>
  *, :after, :before {
    font-family: Roboto,Helvetica Neue,Helvetica,Arial,sans-serif;
  }
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
  /* font-family: 微軟正黑體, sans-serif !important; */
}

  @media screen and (max-width: 1100px) {
    #app {
      overflow: hidden;
    }
  }
  .div_mc{
    width: 100%;
    height: 100%;
    position: absolute;
    margin: 0;
    top: 0;
    left: 0;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue